import { loggerVue } from 'services/logger';

export const JSONParse = (value, logTitle) => {
    try {
        return JSON.parse(value);
    } catch (e) {
        loggerVue.error(e, logTitle);
    }
};
